import React, { useState, useRef  } from 'react';
import styles from './questionAnswers.css';
import { useSelector } from 'react-redux';

/**
 *
 * @type {React.NamedExoticComponent<{readonly setEventSound?: *, readonly contentColor?: *, readonly handleAnswerSelection?: *, readonly question?: *}>}
 */
const QuestionAnswers = React.memo( ( { question, handleAnswerSelection, contentColor, setEventSound } ) => {
    const { localization, localization: { editor_mode_answers: [ answer ] } } = question;
    const { localization: { content }, calendar: { settings } } = useSelector( state => state );
    const [ inputText, setInputText ] = useState( '' );
    let refInputText = useRef();

    const changeText = ( e ) => {
        let text = e.target.value;
        setInputText( text );
    };

    const setSound = () => setEventSound( { events: 'hover' } );

    return (
        <div className={ styles.wrapper }>
            <input
                style={ { color: contentColor.dark } }
                className={ styles.inputAnswer }
                ref={ ( input ) => {
                    refInputText = input;
                } }
                onChange={ changeText }
                placeholder={ content.calendar.input_field_user }
            />
            <hr className={ styles.fieldForUserHr }/>
            <div className={ styles.submitWrap }>
                <button
                    style={ settings && { ...settings.appearance.button_style } }
                    className={ styles.submit }
                    aria-label={ content.calendar.submit_aria_label }
                    onMouseEnter={ setSound }
                    onClick={ () => handleAnswerSelection( {
                        question_localization_id: localization.id,
                        id: answer.id,
                        user_answer: inputText,
                        type: localization.answer_model,
                        text: inputText
                    }, refInputText.value = '' ) }>
                    { content.calendar.submit }
                </button>
            </div>
        </div>
    );
} );

export default QuestionAnswers;
